// Design tokens from the Figma file "Subjects Master - Classroom Pilot Program" (Teacher Dashboard page).
import moment from "moment";

export const TD = {
	navy: "#021e40",
	red: "#ee2d2f",
	yellow: "#ffde5c",
	teal: "#197f9f",
	green: "#0b8457",
	white: "#ffffff",
	canvas: "#fffdf7",
	cream: "#fff9eb",
	creamBorder: "#f1e6cc",
	border: "#e4e7ec",
	borderStrong: "#c9d0da",
	textHeading: "#021e40",
	textBody: "#1f2430",
	textMuted: "#5b6472",
	tintNavy: "#eef2f8",
	tintPink: "#ffefef",
	tintSky: "#e8f9ff",
	tintYellow: "#fff7d6",
	tintMint: "#e3fbf3",
	tintPeach: "#fff5ec",
	pastelPink: "#ffcccc",
	pastelMint: "#84f0cc",
	pastelSky: "#acebff",
	pastelPeach: "#ffe9d5",
	cardShadow: "0px 2px 8px 0px rgba(2, 30, 64, 0.06)",
	// Same font as the rest of the CMS (Ant Design's system font stack, set on body).
	font: "inherit",
	// Side menu background (Commons/Sidebar/Sidebar.style.js), used by the Welcome card.
	sidebar: "#0c1427",
};

/** Icon and tint per subject, matching the colours used for the subjects in the design. */
const SUBJECT_META = {
	civics: { icon: "landmark", tint: TD.tintPink, color: TD.red },
	history: { icon: "globe", tint: TD.tintYellow, color: TD.navy },
	"social studies": { icon: "globe", tint: TD.tintYellow, color: TD.navy },
	science: { icon: "flask", tint: TD.tintMint, color: TD.green },
	math: { icon: "calculator", tint: TD.tintSky, color: TD.teal },
	maths: { icon: "calculator", tint: TD.tintSky, color: TD.teal },
	economics: { icon: "barChart", tint: TD.tintPeach, color: TD.red },
	english: { icon: "bookOpen", tint: TD.tintNavy, color: TD.navy },
	"foreign language": { icon: "languages", tint: TD.tintSky, color: TD.teal },
};

export const subjectMeta = (subject) => SUBJECT_META[(subject || "").trim().toLowerCase()] || { icon: "fileText", tint: TD.tintNavy, color: TD.navy };

export const formatDate = (value) => (value ? moment(value, "YYYY-MM-DD").format("MMM D, YYYY") : "");

export const initials = (firstName, lastName) => `${(firstName || "").trim().charAt(0)}${(lastName || "").trim().charAt(0)}`.toUpperCase() || "?";

/** Progress bar colour: green when on track, yellow when behind, red when far behind. */
export const progressColor = (percent) => (percent >= 60 ? TD.green : percent >= 30 ? TD.yellow : TD.red);

/** Ring colour for class averages: green 80+, teal 70+, yellow below. */
export const averageColor = (percent) => (percent >= 80 ? TD.green : percent >= 70 ? TD.teal : percent >= 50 ? TD.yellow : TD.red);

export const plural = (count, word) => `${count} ${word}${count === 1 ? "" : "s"}`;
